import ImageCard from '@Components/Shared/ImageCard.jsx';

const ImageCardSection = (props) => {
	return (
		<div className="container">
			<h2>{props.SectionTitle}</h2>
			<div className="flex-row">
				{props.ImageCards?.map((card, index) => (
					<ImageCard
                        className='flex-col'
						key={'ImgCard' + index}
						ImgSrc={card.ImgSrc}
						ImgTitle={card.ImgTitle}
						Link={card.Link}
						Description={card.Description}
					/>
				))}
			</div>
		</div>
	);
};

export default ImageCardSection;